<sc-no-data-container [hasData]="this.dataSource.filteredData.length > 0" class="visitor-upfront-registration-list">
  <sc-scroll-pane>
    <table class="mat-table-selection" mat-table [dataSource]="dataSource" matSort matSortActive="{{sortColumn}}"
      [matSortDirection]="sortDirection">
      <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->

      <ng-container matColumnDef="hint">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'hint'|
          translate:['tmc.visitreservation.overview.table.column.hint', translationService.language]}}</th>
        <td mat-cell *matCellDef="let visit">
          <span class="{{c}}" *ngFor="let c of getHintClasses(visit)"></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'name'|
          translate:['tmc.visitreservation.overview.table.column.name', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.name}} </td>
      </ng-container>

      <ng-container matColumnDef="firstname">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'firstname'|
          translate:['tmc.visitreservation.overview.table.column.firstname', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.firstname}} </td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'company'|
          translate:['tmc.visitreservation.overview.table.column.company', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.company}} </td>
      </ng-container>

      <ng-container matColumnDef="visitedPerson">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitedPerson'|
          translate:['tmc.visitreservation.overview.table.column.visitedperson',
          translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.visitedPersonString}} </td>
      </ng-container>

      <ng-container matColumnDef="visitedPersonName">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitedPersonName'|
          translate:['tmc-visit.entity.visit.visitedperson.name', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.visitedPersonName}} </td>
      </ng-container>

      <ng-container matColumnDef="visitedPersonDepartment">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitedPersonDepartment'|
          translate:['tmc-visit.entity.visit.visitedperson.department', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.visitedPersonDepartment}} </td>
      </ng-container>

      <ng-container matColumnDef="numberPlate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'numberPlate'|
          translate:['tmc.visitreservation.overview.table.column.numberplate',
          translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.numberPlate}} </td>
      </ng-container>

      <ng-container matColumnDef="plannedArrival">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'plannedArrival'|
          translate:['tmc.visitreservation.overview.table.column.plannedArrival', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.plannedArrival}} </td>
      </ng-container>

      <ng-container matColumnDef="arrival">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'arrival'|
          translate:['tmc.visitreservation.overview.table.column.arrival', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.arrival}} </td>
      </ng-container>

      <ng-container matColumnDef="leave">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'leave'|
          translate:['tmc.visitreservation.overview.table.column.leave', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.leave}} </td>
      </ng-container>

      <ng-container matColumnDef="registrationCode">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'registration code'|
          translate:['tmc.visitreservation.overview.table.column.registrationcode', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.registrationCode}} </td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitor role'|
          translate:['tmc.visitreservation.overview.table.column.role', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.role}} </td>
      </ng-container>

      <ng-container matColumnDef="instructionsStatus">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'instructionsStatus'|
          translate:['tmc-visit.entity.visit.instructionsStatus', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit">
          <ng-container *ngIf="visit.instructionsStatus">
            {{visit.instructionsStatus | translate:['tmc-visit.common.enum.instructionsStatus.' + visit.instructionsStatus, translationService.language]}}
          </ng-container>
          <ng-container *ngIf="!visit.instructionsStatus">
            {{visit.instructionsStatus | translate:['tmc-visit.common.enum.instructionsStatus.NOT_DONE', translationService.language]}}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="instructionsValidUntil">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'instructionsValidUntil'|
          translate:['tmc-visit.entity.visit.instructionsValidUntil', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.instructionsValidUntil}}</td>
      </ng-container>

      <ng-container matColumnDef="supplementaryEquipments">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'supplementaryEquipments'|
          translate:['tmc-visit.entity.visit.supplementaryEquipments', translationService.language]}}</th>
        <td mat-cell class="multiple-lines text-selection" *matCellDef="let visit"> {{visit.supplementaryEquipments}} </td>
      </ng-container>

      <ng-container matColumnDef="invitationSentDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'invitationSentDate'|
          translate:['tmc-visit.entity.visit.invitationSentDate', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.invitationSentDate}}</td>
      </ng-container>

      <ng-container matColumnDef="lastTerminalRegistrationDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'lastTerminalRegistrationDate'|
          translate:['tmc-visit.entity.visit.lastTerminalRegistrationDate', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.lastTerminalRegistrationDate}}</td>
      </ng-container>

      <ng-container matColumnDef="lastClientRegistrationDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'lastClientRegistrationDate'|
          translate:['tmc-visit.entity.visit.lastClientRegistrationDate', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.lastClientRegistrationDate}}</td>
      </ng-container>

       <ng-container matColumnDef="visitEnd">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitEnd'|
          translate:['tmc-visit.entity.visit.visitEnd', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.visitEnd}}</td>
      </ng-container>

      <ng-container matColumnDef="filler">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let visit"></td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

      <tr mat-row *matRowDef="let visit; columns: columnsToDisplay" [ngClass]="getRowStyles(visit)"
        (click)="toggleSelection(visit)"></tr>

    </table>
  </sc-scroll-pane>
</sc-no-data-container>
